import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { PublishingGroupsManagementPage as Page } from './PublishingGroupsManagementPage'
import { AppStateType } from '../../reducers'
import { selectGroupsDetailedList } from '../../selectors/groupsDetailed'
import { selectAreaReadable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'

const mapStateToProps = (state: AppStateType) => ({
  groupsList: selectGroupsDetailedList(state),
  groupsLoaded: state.groupsDetailed.isLoaded,
  groupsLoading: state.groupsDetailed.isLoading,
  canViewCreateGroupPage: selectAreaReadable(state, {
    area: AREA_CONSTANTS.SETTINGS_CREATE_GROUP,
  }),
  canViewReorderGroupsPage: selectAreaReadable(state, {
    area: AREA_CONSTANTS.SETTINGS_REORDER_GROUPS,
  }),
})

export const PublishingGroupsManagementPage = withRouter(
  connect(mapStateToProps)(Page)
)
